function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  className: "a",
  d: "M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM7,12.727A5.727,5.727,0,1,1,12.727,7,5.734,5.734,0,0,1,7,12.727Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M145.971,70a.97.97,0,1,0,.97.97A.971.971,0,0,0,145.971,70Z",
  transform: "translate(-138.972 -67.089)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M150.727,140a.727.727,0,0,0-.727.727v4.364a.727.727,0,0,0,1.455,0v-4.364A.727.727,0,0,0,150.727,140Z",
  transform: "translate(-143.727 -134.545)"
});

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "currentColor",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.b8dcb651.svg";
export { ForwardRef as ReactComponent };